import { connect } from 'react-redux';
import React from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col
} from "reactstrap";
import { history } from 'helpers';
import { PanelHeader, Button } from "components";
import { Link } from 'react-router-dom';
import { loopbackActions } from '../../actions';
import ErrorModal from "../Components/ErrorModal"
import { withTranslation } from 'react-i18next';

class SupportEdit extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      support: {
        id: '',
        type: '',
        producer: '',
        power: '',
      },
      submitted: false,
      error: null
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    const id = this.props.match.params.id
    this.setState({
      addMode: id == 0
    })
  }

  componentDidMount() {
    const id = this.props.match.params.id
    if (id > 0) {
      this.props.dispatch(loopbackActions.get('plant','supports',id));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({ error: nextProps.error });
    }
    else if (nextProps.editEnd ) {
        history.push('/supports');
    }
    else if (nextProps.support) {
          this.setState({
            support: nextProps.support
          });
    }
  }

  handleChange(e) {

    const { name, value } = e.target;

    let { support } = this.state;

    support[name] = value;

    this.setState({ support });
  }

  handleSubmit(e) {

    e.preventDefault();

    let { support, addMode } = this.state;

    let hasValidationErrors = false;

    this.setState({ submitted: true });

    const { dispatch } = this.props;

    const selectedProjectId = localStorage.getItem('selectedProjectId');

    support.projectId = selectedProjectId;

    if (addMode) {
      delete support.id;     
    }

    dispatch(loopbackActions.edit('plant','supports',support));

  }

  render() {

    const { addMode, loading, error, support } = this.state;
    const { t } = this.props; 

    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          {error && <ErrorModal error={error} onClickHandler={() => { this.setState({ error: null }) }} />}
          <Row>
            <Col md={12} xs={12}>
              <Card>
                <CardHeader>
                  <CardTitle>{(addMode ? t("Aggiungi supporto") : t("Modifica supporto") )}
                    {loading && <img alt="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />}
                  </CardTitle>
                </CardHeader>
                <Form className="form-horizontal" onSubmit={this.handleSubmit}>
                  <CardBody>
                    {/* {!addMode && <Row>
                      <Label sm={2}>ID</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup>
                          <Input
                            type="text"
                            disabled
                            placeholder=""
                            value={support.id}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    } */}

                    <Row>
                      <Label sm={2}>{t("Tipo")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className="">
                          <Input
                            type="text"
                            value={support.type}
                            name='type'
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Label sm={2}>{t("Materiale")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className="">
                          <Input
                            type="text"
                            value={support.material}
                            name='material'
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Label sm={2}>{t("Altezza")} (m)</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className="">
                          <Input
                            type = "number"
                            min = "0"
                            value = {support.height}
                            name = 'height'
                            onChange = {this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                  </CardBody>
                  <CardFooter className="text-right">
                    <Button
                      color="success"
                    >
                      {t("Salva")}
                    </Button>
                    &nbsp;&nbsp;
                    <Link to={"/supports"} onClick={this.onClickCancel}>
                      <Button color="default">{t("Annulla")}</Button>
                    </Link>

                  </CardFooter>
                </Form>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loopback } = state;
  const { supports } = loopback;
  return {
    support: supports && supports.instance,
    error: supports && supports.error,
    editEnd: supports && supports.editEnd,
  };
}

const connectedSupportEdit = withTranslation()(connect(mapStateToProps)(SupportEdit));
export { connectedSupportEdit as SupportEdit };



// WEBPACK FOOTER //
// ./src/views/Supports/SupportEdit.jsx